/* TUMO: homepage click tracking.
   Publishes a Shopify customer event "tumo_home_click" (read by a custom pixel
   that forwards it to GA4) and also calls gtag directly if it exists on the page. */
(function () {
  var NAMES = {
    tumo_exhibition: 'hero',
    tumo_work_of_week: 'work_of_week',
    featured_collection_gYBj7q: 'whats_new',
    tumo_video: 'video',
    tumo_tiles: 'collection_tiles',
    tumo_newsletter: 'newsletter',
    image_with_text_TgBe7E: 'gift_card'
  };

  function sectionName(el) {
    var sec = el.closest('.shopify-section');
    if (!sec || !sec.id) return 'other';
    if (sec.closest('.section-header, #shopify-section-header') || sec.classList.contains('section-header')) return 'header';
    var key = sec.id.replace('shopify-section-', '');
    var short = key.indexOf('__') > -1 ? key.split('__').pop() : key;
    return NAMES[short] || short;
  }

  function partName(a) {
    if (a.classList.contains('th-chip')) return 'chip';
    if (a.classList.contains('button')) return 'button';
    if (a.closest('.th-hero__mosaic, .th-hero__media')) return 'image';
    if (a.classList.contains('th-tile')) return 'tile';
    if (a.closest('.card-wrapper, .card')) return 'product_card';
    return 'link';
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var section = sectionName(a);
    var siblings = a.parentElement ? Array.prototype.filter.call(a.parentElement.children, function (n) { return n.tagName === 'A'; }) : [];
    var data = {
      section: section,
      part: partName(a),
      label: (a.textContent || a.getAttribute('aria-label') || (a.querySelector('img') && a.querySelector('img').alt) || '').replace(/\s+/g, ' ').trim().slice(0, 100),
      url: a.getAttribute('href'),
      position: siblings.indexOf(a) + 1,
      device: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    };
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('tumo_home_click', data);
      }
    } catch (err) {}
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'home_click', {
          home_section: data.section,
          home_part: data.part,
          link_text: data.label,
          link_url: data.url,
          home_position: data.position
        });
      }
    } catch (err) {}
  }, true);
})();
